import { render } from "./DefaultNewestSectionResultCmp.vue?vue&type=template&id=6b6b5058"
import script from "./DefaultNewestSectionResultCmp.vue?vue&type=script&lang=js"
export * from "./DefaultNewestSectionResultCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__